import { styled } from 'src/styles/stitches.config'

export const Wrapper = styled('div', {
    paddingTop: '$md',
    '@lg': {
        paddingTop: '$xl',
    },
    ol: {
        listStyleType: 'none',
        counterReset: 'my-counter',
        li: {
            counterIncrement: 'my-counter',
            position: 'relative',
            '&::before': {
                fontSize: '0.5em',
                content: `'0' counter(my-counter) '/'`,
                position: 'absolute',
                right: 'calc(100% + 1.5rem)',

                whiteSpace: 'nowrap',
            },
        },
    },
})
